module.exports = __webpack_public_path__ + "img/thumbnail_Cassowary_j_normal.0f78469b.png";